import React from 'react';
import {Pages} from "./config";
import {FormattedMessage} from "react-intl";

// Defines routes which can be navigated to from anywhere in the app. A link for each one will appear
// in the sidebar
const appRoutes = [
  {
    path: "/home",
    name: <FormattedMessage id="menu.home" defaultMessage="Home"/>,
    icon: "pe-7s-home",
    component: Pages.Home
  },
  {
    path: "/about",
    name: <FormattedMessage id="menu.about" defaultMessage="About this app"/>,
    icon: "pe-7s-info",
    component: Pages.About
  },
  {
    path: "/guidance",
    name: <FormattedMessage id="menu.guidance" defaultMessage="Guidance"/>,
    icon: "pe-7s-way",
    component: Pages.Guidance
  },
  {
    path: "/accessibility",
    name: <FormattedMessage id="menu.accessibility" defaultMessage="Accessibility"/>,
    icon: "pe-7s-global",
    component: Pages.Accessibility
  },
  {
    path: "/terms",
    name: <FormattedMessage id="menu.terms" defaultMessage="Terms and Conditions"/>,
    icon: "pe-7s-note2",
    component: Pages.Terms
  },
  {
    path: "/privacy",
    name: <FormattedMessage id="menu.privacy" defaultMessage="Privacy Policy"/>,
    icon: "pe-7s-lock",
    component: Pages.Privacy
  },
  {
    path: "/cookie",
    name: <FormattedMessage id="menu.cookie" defaultMessage="Cookie Policy"/>,
    icon: "pe-7s-news-paper",
    component: Pages.Cookie
  },
  {
    path: "/contacts",
    name: <FormattedMessage id="menu.contacts" defaultMessage="Contacts"/>,
    icon: "pe-7s-mail",
    component: Pages.Contacts
  },
];

export default appRoutes;
